export const EMAIL_EMBED_CLICK = {
    url: '/trk/engagement:click_email_embed',
    isUserEngagement: true,
    consent: 'essential',
};
export const CHAT_CLICK_MODERATOR_LINK = {
    url: '/trk/engagement:click_moderator_link',
    isUserEngagement: true,
    consent: 'essential',
};
export const FEED_CLICK_VIDEO = {
    url: '/trk/feed:click_video',
    isUserEngagement: false,
    consent: 'essential',
};
export const FEED_REDIRECT_FULLSCREEN_IMPRESSION = {
    url: '/trk/feed:create_redirect_fullscreen_impression',
    isUserEngagement: false,
    consent: 'essential',
};
// Used for livestreams
export const PLAYER_CLICK_SHARE_VIDEO = {
    url: '/trk/engagement:click_share_video',
    isUserEngagement: true,
    consent: 'essential',
};
// Used for short videos
export const PLAYER_SHARE_VIDEO = {
    url: '/trk/engagement:share_video',
    isUserEngagement: true,
    consent: 'essential',
};
export const TOGGLE_QR_CODE_HEADER = {
    url: '/trk/engagement:click_qrcode_toggle',
    isUserEngagement: true,
    consent: 'essential',
};
export const VIDEO_PLAYER_CLICK_PAUSE = {
    url: '/trk/video_player:click_pause',
    isUserEngagement: false,
    consent: 'essential',
};
export const VIDEO_PLAYER_CLICK_RESUME = {
    url: '/trk/video_player:click_resume',
    isUserEngagement: false,
    consent: 'essential',
};
export const VIDEO_PLAYER_DISMISS = {
    url: '/trk/video_player:dismiss',
    isUserEngagement: false,
    consent: 'essential',
};
export const VIDEO_PLAYER_MUTE = {
    url: '/trk/video_player:mute',
    isUserEngagement: false,
    consent: 'essential',
};
export const VIDEO_PLAYER_NEXT_VIDEO = {
    url: '/trk/video_player:next_video',
    isUserEngagement: false,
    consent: 'essential',
};
export const VIDEO_PLAYER_PREV_VIDEO = {
    url: '/trk/video_player:prev_video',
    isUserEngagement: false,
    consent: 'essential',
};
export const VIDEO_PLAYER_START_VIDEO = {
    url: '/trk/video_player:start_video',
    isUserEngagement: false,
    consent: 'essential',
};
export const VIDEO_PLAYER_UNMUTE = {
    url: '/trk/video_player:unmute',
    isUserEngagement: false,
    consent: 'essential',
};
export const VIDEO_PLAYER_INIT = {
    url: '/trk/video_player:init',
    isUserEngagement: false,
    consent: 'essential',
};
export const GATED_VIDEO_CORRECT_ACCESS_CODE = {
    url: '/trk/gated_video:correct_access_code',
    isUserEngagement: true,
    consent: 'essential',
};
export const GATED_VIDEO_INCORRECT_ACCESS_CODE = {
    url: '/trk/gated_video:incorrect_access_code',
    isUserEngagement: true,
    consent: 'essential',
};
// These are not in Player context
export const VIDEO_PLAYER_ENTER_PIP = {
    url: '/trk/video_player:pip_enter',
    isUserEngagement: false,
    consent: 'essential',
};
export const VIDEO_PLAYER_EXIT_PIP = {
    url: '/trk/video_player:pip_exit',
    isUserEngagement: false,
    consent: 'essential',
};
export const VIDEO_PLAYER_FAILED_PIP = {
    url: '/trk/video_player:pip_failed',
    isUserEngagement: false,
    consent: 'essential',
};
export const INTERACTION_PILL_CLICK = {
    url: '/trk/livestream:pill_click',
    isUserEngagement: true,
    consent: 'essential',
};
export const INTERACTION_PILL_IMPRESSION = {
    url: '/trk/livestream:pill_impression',
    isUserEngagement: false,
    consent: 'essential',
};
export const TRIVIA_GIVEAWAY_QUESTION_IMPRESSION = {
    url: '/trk/livestream:trivia_giveaway_question_impression',
    isUserEngagement: false,
    consent: 'essential',
};
export const TRIVIA_GIVEAWAY_QUESTION_OPTION_CLICK = {
    url: '/trk/livestream:trivia_giveaway_question_option_click',
    isUserEngagement: true,
    consent: 'essential',
};
export const EMAIL_FORM_IMPRESSION = {
    url: '/trk/livestream:email_form_impression',
    isUserEngagement: false,
    consent: 'essential',
};
export const EMAIL_FORM_SUBMIT = {
    url: '/trk/livestream:email_form_submit',
    isUserEngagement: true,
    consent: 'essential',
};
/**
 * Diagnostics
 */
export const VIDEO_PLAYER_LOAD_TIME = {
    url: '/dx/video_player:load_time',
    isUserEngagement: false,
    consent: 'essential',
};
